const makeHash = (str) => str.split('').reduce((prev, next) => (prev = ((prev << 5) - prev) + next.charCodeAt(0)) & prev, 0); // eslint-disable-line no-bitwise
const TIMEOUT_ERR = {
    httpCode: 408,
    message : 'Debounce timeout',
    code    : -32409
};

class DebounceQueue {

    constructor(timeout, hash) {
        this._timeoutMs = timeout;
        this._createdAt = Date.now();
        this.hash = hash;
        this._items = [];
    }

    get length() {
        return this._items && this._items.length || 0;
    }

    add(debounceMs, params, reject) {
        const now = Date.now();

        if(typeof this._timeoutMs === 'number' && debounceMs !== this._timeoutMs) {
            console.warn(`Multiple items in the debounce queue with different debounce timeout, using first timeout value ${
                this._timeoutMs
            }ms, see request parameters below`
            );
            console.warn(params);
        }
        if((now - this._createdAt) < this._timeoutMs) {
            this._items.forEach((reject) => reject(TIMEOUT_ERR));
            this._items = [];
        }
        this._items.push(reject);
    }

    destroy() {
        this._items = null;
    }

}

export default class DebounceManager {

    constructor() {
        this.timeoutId = null;
        this.queues = new Map();
    }

    add(debounceMs, params, reject) {
        const hash = makeHash(String(params));
        let queue = this.queues.get(hash);

        if(!queue) {
            queue = new DebounceQueue(debounceMs, hash);
            this.queues.set(queue.hash, queue);
            setTimeout(this.queues.delete.bind(this.queues, queue.hash), debounceMs);
        }
        queue.add(debounceMs, params, reject);
    }

}



// WEBPACK FOOTER //
// ./node_modules/core-ui__transport/debounceManager.js